/**
 * @generated SignedSource<<453e1bedc78fccde5cfbccbc9ec2a02d>>
 * @relayHash f2c7abd21d59830dd2d979b6bbbf41b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cba055eb6dd9c705f3aaf258f65f5efd93ba59326dfe3e51e4f4cdf36bb81099

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cba055eb6dd9c705f3aaf258f65f5efd93ba59326dfe3e51e4f4cdf36bb81099",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
